export default __webpack_public_path__ + "static/media/sos.c300217e.svg";